module.exports = __webpack_public_path__ + "static/media/home-sample-2.68173ed7.png";